import { Router } from '../router/Router';

export class LandingPage {
  private element: HTMLElement;
  private router: Router;

  constructor(container: HTMLElement, router: Router) {
    this.router = router;
    this.element = document.createElement('div');
    this.element.className = 'landing-page';
    this.render();
    container.appendChild(this.element);
    this.bindEvents();
  }

  private render(): void {
    this.element.innerHTML = `
      <div class="landing-container">
        <header class="landing-header">
          <div class="landing-logo">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 2c0 10-10 10-10 10s10 0 10 10"/>
              <path d="M12 2c0 10 10 10 10 10s-10 0-10 10"/>
            </svg>
            <span>Tennis Diagrams</span>
          </div>
        </header>

        <main class="landing-hero">
          <h1>Draw plays. Share tactics.</h1>
          <p class="landing-tagline">We coaches, not artists</p>

          <button class="create-btn" id="create-new">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Create New Diagram
          </button>

          <ul class="landing-features">
            <li>Drag to draw shot trajectories</li>
            <li>Automatic bounce trajectory arcs</li>
            <li>Rally sequencing with hit numbers</li>
            <li>Export as PNG for sharing</li>
          </ul>
        </main>

        <footer class="landing-footer">
          <p>Built for tennis coaches</p>
        </footer>
      </div>
    `;
  }

  private bindEvents(): void {
    const createBtn = this.element.querySelector('#create-new');
    createBtn?.addEventListener('click', () => {
      this.router.navigate('/new');
    });
  }

  destroy(): void {
    this.element.remove();
  }
}
